import { render, staticRenderFns } from "./taskagents.vue?vue&type=template&id=38c20250"
import script from "./taskagents.vue?vue&type=script&lang=js"
export * from "./taskagents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports